import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Field } from 'redux-form'
import { Button } from 'semantic-ui-react'
import ReactTable from 'react-table'
import { noCase, titleCase } from 'change-case'
import { IconButton, Collapse, Card, CardHeader, CardContent } from '@material-ui/core'
import { ExpandMore, ExpandLess } from '@material-ui/icons'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { BankGuaranteeInformationContainer, TypeOfBondContent } from './styled'
import { getVendors, getCompanies } from 'ducks/options'
import { getVendorContacts } from 'ducks/bankGuarantee'
import { getBgRelated, getRefBGRequestOptions, getLoadAmount, clearBgRef, getTotalActiveAmount } from 'ducks/bankGuaranteeRequest'
import { isNullOrEmpty } from 'core/utilities'
import { columnBgRelated, columnNewBG } from 'routes/BankGuarantee/AttributeData'
import NewBankGuaranteeModal from '../NewBankGuaranteeModal'

const BankGuaranteeInformation = (props) => {
  const { valueForm={}, change, vendorOptions, companyOptions, bgRefOptions, isDisplay=false } = props
  const [showBankGuaranteeInfo, setShowBankGuaranteeInfo] = useState(true)
  const [showNewBGModal, setShowNewBGModal] = useState(false)
  const [newBgData, setNewBgData] = useState(undefined)
  const [newBgIndex, setNewBgIndex] = useState(undefined)
  const [loadedContact, setLoadedContact] = useState('')
  const [changeVendor, setChangeVendor] = useState(false)
  var listNewBG = valueForm.newBankGuarantees || []

  useEffect(() => {
    if (!vendorOptions.data.length && !vendorOptions.loading) {
      props.getVendors()
    }

    if (!companyOptions.data.length && !companyOptions.loading) {
      props.getCompanies()
    }

    if (!bgRefOptions.data.length && !bgRefOptions.loading) {
      props.getRefBGRequestOptions()
    }

    return () => {
      props.clearBgRef()
    }
  }, [])

  useEffect(() => {
    const { vendorCode, status } = valueForm
    if (status !== null && status !== undefined && vendorCode && loadedContact === '') {
      setLoadedContact(vendorCode)
    }
  }, [valueForm.status])

  useEffect(() => {
    const { vendorCode, companyCode } = valueForm
    if (vendorCode && companyCode && vendorCode !== loadedContact && changeVendor) {
      props.getVendorContacts(vendorCode, companyCode, onGetVendorContactSuccess)
    }

    if (vendorCode && companyCode) {
      props.getLoadAmount(vendorCode, companyCode, (data) => {
        change('loadAmount', data)
      })
  
      props.getTotalActiveAmount(vendorCode, companyCode, (data) => {
        change('totalBgAmount', data)
      })
    }
  }, [valueForm.vendorCode, valueForm.companyCode])

  const editableForm = () => {
    if (valueForm.status !== 0 && valueForm.status !== undefined && valueForm.status !== null) {
      return !isDisplay && !isNullOrEmpty(valueForm.sn) && !isNullOrEmpty(valueForm.requestType)
    } else {
      if (valueForm.creator === props.username) {
        return !isDisplay && !isNullOrEmpty(valueForm.requestType)
      } else {
        return false
      }
    }
  }

  const companyOption = () => {
    if(isDisplay){
      return companyOptions.data
    }else{
      var uniqueListCode = [...new Set(bgRefOptions.data.map(x => x.companyCode))]
      if (valueForm.vendorCode) {
        uniqueListCode = [...new Set(bgRefOptions.data.filter(x => x.vendorCode === valueForm.vendorCode).map(x => x.companyCode))]
      }
      return companyOptions.data.filter(x => uniqueListCode.includes(x.value))
    }
  }

  const vendorOption = () => {
    if(isDisplay){
      return vendorOptions.data
    }else{
      var uniqueListCode = [...new Set(bgRefOptions.data.map(x => x.vendorCode))]
      if (valueForm.companyCode) {
        uniqueListCode = [...new Set(bgRefOptions.data.filter(x => x.companyCode === valueForm.companyCode).map(x => x.vendorCode))]
      }
      return vendorOptions.data.filter(x => uniqueListCode.includes(x.value))
    }
  }

  const bgOption = () => {
    var result = bgRefOptions.data.map(x => ({ ...x, value: x.id }))

    if (!isNullOrEmpty(valueForm.companyCode)) {
      result = result.filter(x => x.companyCode === valueForm.companyCode)
    }

    if (!isNullOrEmpty(valueForm.vendorCode)) {
      result = result.filter(x => x.vendorCode === valueForm.vendorCode)
    }

    var listBgOriginalSelectedId = []
    var bgRelates = valueForm.bgRelates || []
    bgRelates.forEach((x, index) => {
      if (x.documentType === 'original') {
        listBgOriginalSelectedId.push(x.bankGuaranteeId)
      }
    })

    if (listBgOriginalSelectedId.length) {
      result = result.filter(x => !listBgOriginalSelectedId.includes(x.id))
    }

    if (!isNullOrEmpty(valueForm.typeOfBond) && valueForm.requestType === 'change') {
      result = result.filter(x => x.typeOfBond === valueForm.typeOfBond)
    }

    return result
  }

  const bgRelatedData = () => {
    var bgRelates = valueForm.bgRelates || []

    var result = []
    var watchOriginalId = 0
    var showExtend = false
    bgRelates.forEach((x, index) => {
      if (x.documentType === 'original') {
        result.push({...x, rawIndex: index})
        watchOriginalId = x.bankGuaranteeId
        showExtend = x.showExtend
      } else {
        if (x.nestedId === watchOriginalId && showExtend && x.documentType === 'extend') {
          result.push(x)
        }
      }
    })

    return result
  }

  const onDeleteBgRelated = (id) => {
    var result = []
    var bgRelates = valueForm.bgRelates || []
    bgRelates.forEach((data) => {
      if ((data.documentType === 'original' && data.bankGuaranteeId !== id) ||
          (data.documentType === 'extend' && data.nestedId !== id)) {
        result.push(data)
      }
    })
    change('bgRelates', result)

    if (result.length === 0) {
      change('typeOfBond', '')
    }
  }

  const showBgExtendRelated = (index) => {
    change(`bgRelates[${index}].showExtend`, !valueForm.bgRelates[index].showExtend)
  }

  const onSubmitNewBgData = (data, isNew, oldData, index) => {
    if (isNew) {
      change('newBankGuarantees', [...listNewBG, data])
    } else {
      change(`newBankGuarantees[${index}]`, data)
    }
  }

  const showModalEditNewBG = (index) => {
    setNewBgData(listNewBG[index])
    setNewBgIndex(index)
    setShowNewBGModal(true)
  }

  const onDeleteNewBG = (userIndex) => {
    var clone = [...(valueForm.newBankGuarantees || [])]
    clone.splice(userIndex, 1)
    change('newBankGuarantees', [...clone])
  }

  const disableAddBgRelatedButton = () => {
    var bgOriginalRelates = ((valueForm.bgRelates || []).filter(x => x.documentType === 'original') || []).length
    var newBg = (valueForm.newBankGuarantees || []).length

    if (newBg > 1 && bgOriginalRelates > 0) return true

    return false
  }

  const disableAddNewBgButton = () => {
    var bgOriginalRelates = ((valueForm.bgRelates || []).filter(x => x.documentType === 'original') || []).length
    var newBg = (valueForm.newBankGuarantees || []).length

    if (bgOriginalRelates > 1 && newBg > 0) return true

    return false
  }

  const onGetVendorContactSuccess = (data) => {
    change('vendorContacts', data)
    setChangeVendor(false)
    setLoadedContact(valueForm.vendorCode)
  }

  return (
    <Card style={{ marginTop: '10px' }}>
      <CardHeader 
        title='Bank Guarantee Information'
        action={
          <IconButton aria-label='Expand' onClick={() => setShowBankGuaranteeInfo(!showBankGuaranteeInfo) }>
            {showBankGuaranteeInfo ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        }
      />
      <Collapse in={showBankGuaranteeInfo}>
        <CardContent>
          <BankGuaranteeInformationContainer>
            <div className='rowFields'>
              <Field 
                name='companyCode' 
                label='Company'
                require 
                options={companyOption()} 
                loading={companyOptions.loading}
                editable={editableForm()}
                specialOnChange={(value) => {
                  change('bgRelates', [])
                  change('newBankGuarantees', [])
                  change('typeOfBond', '')
                  change('loadAmount', 0)
                  change('totalBgAmount', 0)
                  
                  if (valueForm.vendorCode) {
                    var bgs = bgRefOptions.data.filter(x => x.companyCode === value && x.vendorCode === valueForm.vendorCode) || []
                    if (bgs.length === 0) {
                      change('vendorCode', '')
                    }
                  }
                }}
                type={type.select} 
                component={FieldInput} 
              />
              <Field 
                name='vendorCode' 
                label='Vendor' 
                require
                options={vendorOption()} 
                loading={vendorOptions.loading} 
                editable={editableForm()} 
                specialOnChange={(value) => {
                  change('bgRelates', [])
                  change('newBankGuarantees', [])
                  change('typeOfBond', '')
                  change('loadAmount', 0)
                  change('totalBgAmount', 0)
                  setChangeVendor(true)
                  if (valueForm.companyCode) {
                    var bgs = bgRefOptions.data.filter(x => x.vendorCode === value && x.companyCode === valueForm.companyCode) || []
                    if (bgs.length === 0) {
                      change('companyCode', '')
                    }
                  }
                  if (value === '') {
                    setLoadedContact(value)
                  }
                }}
                type={type.select} 
                component={FieldInput} 
              />
            </div>
            <div className='rowFields'>
              <Field 
                name='loadAmount' 
                label='ภาระ (THB)' 
                editable={false}  
                type={type.number} 
                component={FieldInput} 
              />
              <Field 
                name='totalBgAmount' 
                label='Summary BG' 
                editable={false}  
                type={type.number} 
                component={FieldInput} 
              />
            </div>
            <div className='rowFields'>
              {
                editableForm() ?
                  <Field 
                    name='bgRelatedSelect' 
                    label='Bank Guarantee Related' 
                    require
                    editable={editableForm()}
                    options={bgOption()}
                    loading={bgRefOptions.loading}
                    type={type.select} 
                    component={FieldInput} 
                  /> : <div />
              }
              <div style={{ 
                display: 'flex',
                flex: 1, 
                justifyContent: 'space-between',
                paddingTop: '22px', 
                marginRight: '15px',
                paddingBottom: '15px',
              }}>
                {
                  editableForm() ?
                    <Button
                      color='blue'
                      content='Add'
                      type='button'
                      disabled={disableAddBgRelatedButton()}
                      onClick={() => { 
                        var bgOption = bgRefOptions.data.find(x => x.id === valueForm.bgRelatedSelect)
                        if (bgOption != null) {
                          if (valueForm.vendorCode !== bgOption.vendorCode) {
                            setChangeVendor(true)
                          }
                          props.getBgRelated(bgOption.id, (data) => {
                            if ((valueForm.bgRelates || []).length === 0 && (data || []).length > 0) {
                              change('typeOfBond', data[0].typeOfBond)
                            }
    
                            change('companyCode', bgOption.companyCode)
                            change('vendorCode', bgOption.vendorCode)
                            change('bgRelates', [...(valueForm.bgRelates), ...data])
                            change('bgRelatedSelect', '')
                          })
                        }
                      }}
                    /> : <div />
                }
                {
                  valueForm.requestType === 'change' ?
                    <TypeOfBondContent>
                      Type of Bond : {titleCase(noCase(valueForm.typeOfBond))}
                    </TypeOfBondContent> : null
                }
              </div>
            </div>
            <ReactTable
              data={bgRelatedData()}
              columns={columnBgRelated(editableForm(), onDeleteBgRelated, showBgExtendRelated)}
              sortable={false}
              resizable={false}
              pageSize={bgRelatedData().length > 1 ? bgRelatedData().length : 1}
              defaultPageSize={bgRelatedData().length > 1 ? bgRelatedData().length : 1}
              className='-striped -highlight'
              NoDataComponent={() => null}
              showPagination={false}
            />
            {
              valueForm.requestType === 'change' ? 
              <div style={{ flex: 1, paddingTop: '22px', flexDirection: 'row' }}>
                <div style={{ fontWeight: 'bold', fontSize: '1.25rem' }}>
                  New Bank Guarantee
                  <Field name='newBgMessage' label='' type={type.labelOnly} component={FieldInput} 
                  />
                </div>
                {
                  (valueForm.bgRelates || []).filter(x => x.documentType === 'original').length > 1 ?
                  <div style={{ marginBottom: '5px', color: '#888888' }}>
                    กรณีที่เลือก change Original BG มากกว่า 1 รายการ จะสามารถ Add New BG ได้ 1 รายการเท่านั้น
                  </div> : null
                }
                {
                  editableForm() ?
                    <Button
                      color='blue'
                      content='Add'
                      type='button'
                      icon='plus'
                      labelPosition='left'
                      disabled={disableAddNewBgButton()}
                      onClick={() => setShowNewBGModal(true)}
                    /> : null
                }
                <ReactTable
                  data={listNewBG}
                  columns={columnNewBG(editableForm(), showModalEditNewBG, onDeleteNewBG)}
                  sortable={false}
                  pageSize={listNewBG.length > 1 ? listNewBG.length : 1}
                  defaultPageSize={listNewBG.length > 1 ? listNewBG.length : 1}
                  className='-striped -highlight'
                  style={{ marginTop: '10px' }}
                  NoDataComponent={() => null}
                  showPagination={false}
                />
              </div> : null
            }
            {
              showNewBGModal ? 
                <NewBankGuaranteeModal 
                  newBgData={newBgData}
                  newBgIndex={newBgIndex}
                  listNewBG={listNewBG}
                  clearNewBgData={() => {
                    setNewBgData(undefined)
                    setNewBgIndex(undefined)
                  }}
                  closeModal={() => setShowNewBGModal(false)} 
                  onSubmitData={onSubmitNewBgData}
                /> : null
            }
          </BankGuaranteeInformationContainer>
        </CardContent>
      </Collapse>
    </Card>
  )
}

const mapStateToProps = (state) => {
  const user = state.authen.user || {}
  const username = user.username || ''
  return ({
    username,
    jobs: state.bg.jobs,
    bankOwners: state.bg.bankOwners,
    financeUser: state.bg.financeUser,
    vendorOptions: state.options.vendors,
    companyOptions: state.options.companies,
    bgRefOptions: state.bgRequest.bgRefOptions,
  })
}
  
const mapDispatchToProps = {
  getVendors, 
  getCompanies,
  getRefBGRequestOptions,
  getBgRelated,
  getVendorContacts,
  getLoadAmount,
  clearBgRef,
  getTotalActiveAmount
}

export default connect(mapStateToProps, mapDispatchToProps)(BankGuaranteeInformation)